/* sc-colecao-black — comportamento da pagina da colecao da Black (sections/sc-colecao-black.liquid)
   Desde 30/10 tambem roda nas secoes da home (sc-home-produtos, sc-home-dupla-video): cada
   [data-scbc] da pagina e iniciado uma vez so (data-ok), entao o arquivo pode ser carregado por
   mais de uma secao. */
(function () {
  var todas = document.querySelectorAll('[data-scbc]');
  for (var ri = 0; ri < todas.length; ri++) iniciar(todas[ri]);

  function iniciar(raiz) {
  if (raiz.getAttribute('data-ok')) return;
  raiz.setAttribute('data-ok', '1');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var html = document.documentElement;
  var desk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  /* regras: abertas no desktop (3 colunas), sanfona no celular com a 1a aberta */
  function regras() {
    var ds = raiz.querySelectorAll('.scbc-regra');
    for (var i = 0; i < ds.length; i++) {
      if (desk && desk.matches) ds[i].setAttribute('open', '');
      else if (i > 0 && !ds[i].hasAttribute('data-mexeu')) ds[i].removeAttribute('open');
    }
  }
  regras();
  if (desk && desk.addEventListener) desk.addEventListener('change', regras);
  raiz.addEventListener('toggle', function (e) { if (e.target && e.target.classList && e.target.classList.contains('scbc-regra')) e.target.setAttribute('data-mexeu', ''); }, true);

  /* barra do rodape: escondida enquanto a vitrine do presente esta na tela */
  var vit = raiz.querySelector('[data-scbc-vit]');
  if (vit && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { html.classList.toggle('scbc-vit-on', e.isIntersecting); });
    }, { threshold: 0 }).observe(vit);
  }

  var filt = raiz.querySelector('[data-scbc-filt]');

  /* filtros e "ver mais" */
  var grade = raiz.querySelector('[data-scbc-grid]');
  var conta = raiz.querySelector('[data-scbc-conta]');
  var cards = grade ? grade.querySelectorAll('[data-scbc-card]') : [];
  var total = cards.length;
  function visiveis() {
    var n = 0;
    for (var i = 0; i < cards.length; i++) if (cards[i].offsetParent !== null) n++;
    return n;
  }
  function contar() { if (conta) conta.textContent = 'Mostrando ' + visiveis() + ' de ' + total + ' peças'; }
  raiz.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-scbc-cat]');
    if (ch && grade) {
      var cat = ch.getAttribute('data-scbc-cat');
      var bs = raiz.querySelectorAll('[data-scbc-cat]');
      for (var i = 0; i < bs.length; i++) { var on = bs[i] === ch; bs[i].classList.toggle('is-on', on); bs[i].setAttribute('aria-pressed', on ? 'true' : 'false'); }
      grade.classList.toggle('is-filtro', !!cat);
      for (var j = 0; j < cards.length; j++) cards[j].hidden = !!cat && cards[j].getAttribute('data-cat') !== cat;
      contar();
      if (filt && filt.getBoundingClientRect().top < 0) filt.scrollIntoView({ block: 'start' });
      return;
    }
    if (e.target.closest('[data-scbc-ver]') && grade) {
      grade.classList.add('is-aberta');
      contar();
    }
  });

  /* ordenacao: recarrega com ?sort_by= mantendo o resto (view, preview_theme_id...) */
  var sel = raiz.querySelector('[data-scbc-sort]');
  if (sel) sel.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- bolinhas de cor e metal nos cards ---------- */
  function escH(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clsMetal(m) {
    var s = String(m).toLowerCase();
    return /dourad|ouro|gold/.test(s) ? 'is-ouro' : /prata|silver|925/.test(s) ? 'is-prata' : 'is-outro';
  }
  function dadosDo(card) {
    if (card._scbc !== undefined) return card._scbc;
    var el = card.querySelector('[data-scbc-dados]'), d = null;
    try { d = el ? JSON.parse(el.textContent) : null; } catch (x) { d = null; }
    if (d) { d.c = Number(card.getAttribute('data-c')) || 0; d.v = Number(card.getAttribute('data-v')) || 0; }
    card._scbc = d;
    return d;
  }
  function pintar(card) {
    var d = dadosDo(card);
    if (!d || !d.cores[d.c]) return;
    var cor = d.cores[d.c], v = cor.v[d.v] || cor.v[0];
    var bs = card.querySelectorAll('[data-scbc-cor]');
    for (var i = 0; i < bs.length; i++) {
      var on = Number(bs[i].getAttribute('data-scbc-cor')) === d.c;
      bs[i].classList.toggle('is-on', on);
      bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var mr = card.querySelector('[data-scbc-metais]');
    if (mr) {
      if (cor.v.length > 1) {
        mr.hidden = false;
        mr.innerHTML = cor.v.map(function (x, k) {
          var on = k === d.v;
          return '<button type="button" class="scbc-sw scbc-sw--m ' + clsMetal(x.m) + (on ? ' is-on' : '') + '" data-scbc-met="' + k +
            '" title="' + escH(x.m) + '" aria-label="Metal ' + escH(x.m) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (x.ok ? '' : ' disabled') + '><i></i></button>';
        }).join('') + '<span class="scbc-sws__n" data-scbc-metn>' + escH(v.m) + '</span>';
      } else {
        mr.hidden = true;
      }
    }
    var img = card.querySelector('.scbc-card__ph img');
    if (img && v.img && img.getAttribute('src') !== v.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', v.img);
    }
    var url = cor.url + (cor.v.length > 1 ? (cor.url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + v.id : '');
    var ls = card.querySelectorAll('.scbc-card__ph, .scbc-card__nm');
    for (var j = 0; j < ls.length; j++) ls[j].setAttribute('href', url);
    var pr = card.querySelector('.scbc-card__pr'), pc = card.querySelector('.scbc-card__pc');
    if (pr) pr.textContent = v.pr;
    if (pc) pc.textContent = v.pc;
    var add = card.querySelector('.scbc-add[data-scbc-add]');
    if (add) { add.setAttribute('data-scbc-add', v.id); add.disabled = !v.ok; }
  }
  function escolherCor(card, ci) {
    var d = dadosDo(card);
    if (!d || !d.cores[ci]) return;
    var antes = (d.cores[d.c] && d.cores[d.c].v[d.v]) ? d.cores[d.c].v[d.v].m : null;
    var vs = d.cores[ci].v, alvo = -1;
    for (var i = 0; i < vs.length; i++) if (vs[i].ok && vs[i].m === antes) { alvo = i; break; }
    if (alvo < 0) for (var k = 0; k < vs.length; k++) if (vs[k].ok) { alvo = k; break; }
    d.c = ci; d.v = alvo < 0 ? 0 : alvo;
    pintar(card);
  }
  var comDados = raiz.querySelectorAll('[data-scbc-card][data-c]');
  for (var q = 0; q < comDados.length; q++) pintar(comDados[q]);

  /* ---------- carrinho ---------- */
  function avisarTema() {
    ['cart:refresh', 'cart:build', 'cart:change'].forEach(function (nome) {
      html.dispatchEvent(new CustomEvent(nome, { bubbles: true }));
    });
  }
  function abrirGaveta(irEscolha) {
    avisarTema();
    var g = document.querySelector('cart-drawer');
    if (!g || typeof g.show !== 'function') { window.location.href = root + 'cart'; return; }
    if (!g.hasAttribute('open')) g.show();
    if (!irEscolha) return;
    var t0 = Date.now();
    (function tenta() {
      var alvo = document.querySelector('cart-drawer .sc-bf-pk');
      if (alvo && g.hasAttribute('open')) {
        setTimeout(function () { try { alvo.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {} }, 350);
        return;
      }
      if (Date.now() - t0 < 4000) setTimeout(tenta, 120);
    })();
  }
  function adicionar(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }
  function fecharEscolhas(exceto) {
    var abertas = raiz.querySelectorAll('.scbc-esc:not([hidden])');
    for (var i = 0; i < abertas.length; i++) {
      if (abertas[i] === exceto) continue;
      abertas[i].hidden = true;
      var b = abertas[i].parentNode.querySelector('[data-scbc-abre]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.scbc-esc') && !e.target.closest('[data-scbc-abre]')) fecharEscolhas(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fecharEscolhas(null); });

  raiz.addEventListener('click', function (e) {
    var ab = e.target.closest('[data-scbc-abre]');
    if (ab) {
      var esc = ab.parentNode.querySelector('.scbc-esc');
      if (!esc) return;
      var abrir = esc.hidden;
      fecharEscolhas(esc);
      esc.hidden = !abrir;
      ab.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir) { var f = esc.querySelector('button:not([disabled])'); if (f) f.focus(); }
      return;
    }

    var sc = e.target.closest('[data-scbc-cor]');
    if (sc) { escolherCor(sc.closest('[data-scbc-card]'), Number(sc.getAttribute('data-scbc-cor'))); return; }
    var sm = e.target.closest('[data-scbc-met]');
    if (sm && !sm.disabled) {
      var cm = sm.closest('[data-scbc-card]'), dm = dadosDo(cm);
      if (dm) { dm.v = Number(sm.getAttribute('data-scbc-met')); pintar(cm); }
      return;
    }

    var bt = e.target.closest('[data-scbc-add]');
    if (bt && !bt.disabled) {
      var media = bt.closest('.scbc-card__media');
      var mais = media ? media.querySelector('.scbc-add') : bt;
      bt.disabled = true;
      if (mais) mais.classList.add('is-load');
      adicionar([{ id: Number(bt.getAttribute('data-scbc-add')), quantity: 1 }]).then(function () {
        fecharEscolhas(null);
        if (mais) { mais.classList.remove('is-load'); mais.classList.add('is-ok'); setTimeout(function () { mais.classList.remove('is-ok'); }, 1600); }
        bt.disabled = false;
        abrirGaveta(false);
      }).catch(function (err) {
        if (mais) mais.classList.remove('is-load');
        bt.disabled = false;
        var msg = (err && err.description) || 'Não deu para adicionar. Tente de novo.';
        if (media) {
          var av = media.querySelector('.scbc-tag--erro');
          if (!av) { av = document.createElement('span'); av.className = 'scbc-tag scbc-tag--erro'; media.appendChild(av); }
          av.textContent = msg.length > 60 ? 'Sem estoque agora' : msg;
          setTimeout(function () { if (av.parentNode) av.parentNode.removeChild(av); }, 3500);
        }
      });
      return;
    }

    var du = e.target.closest('[data-scbc-dupla]');
    if (du && !du.disabled) {
      var orig = du.textContent;
      du.disabled = true;
      du.textContent = 'Adicionando...';
      var id1 = String(du.getAttribute('data-id-1')), id2 = String(du.getAttribute('data-id-2'));
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var tem = {};
          (cart.items || []).forEach(function (it) { tem[String(it.id)] = true; });
          var faltam = [];
          if (!tem[id1]) faltam.push({ id: Number(id1), quantity: 1 });
          if (!tem[id2] && id2 !== id1) faltam.push({ id: Number(id2), quantity: 1 });
          if (!faltam.length) return null;
          return adicionar(faltam);
        })
        .then(function () { du.disabled = false; du.textContent = orig; abrirGaveta(true); })
        .catch(function () {
          du.textContent = 'Tente de novo';
          setTimeout(function () { du.disabled = false; du.textContent = orig; }, 2400);
        });
    }
  });
  }
})();
